import DataTable from './dataTable'
/******************************************************************************
 *  Reserves
 *****************************************************************************/

/**
 * @type {Reserve}
 */
export default class Reserve extends DataTable {
    /**
     * @param {String} resource
     */
    constructor () {
        super('/availability/units/reserves', '/reserves')
        this.columns = [
            this.prototypes.column('id_reserve', 'availability_units_reserves.id', true, true),
            this.prototypes.column('reserve_created_at', 'availability_units_reserves.created_at', true, true),
            this.prototypes.column('reserved.first_name', 'us.first_name', true, true),
            this.prototypes.column('managed_user_name', 'usm.first_name', true, true),
            this.prototypes.column('requestered_user_name', 'usr.first_name', true, true),
            this.prototypes.column('units.availability.product.name', 'p.id', true, false),
            this.prototypes.column('units', 'availability_units_reserves.unity_id', true, false),
            this.prototypes.column('customer_name', 'c.name', true, false),
            this.prototypes.column('funnel_stage_name', 'fs.name', true, true),
            this.prototypes.column('funnel_stage_status_name', 'fss.name', true, true),
            this.prototypes.column('', 'order_reservation_expiration_date', false, true),
            this.prototypes.column('queued', 'queued', false, false),
            this.prototypes.column('status_reserve', 'availability_units_reserves.status', true, true),
            this.prototypes.column('9', '', false, false),
            this.prototypes.column('reserved_group_id', 'g.id', true, true),
            this.prototypes.column('units.block', 'u.block', true, false),
            this.prototypes.column('units.number', 'u.number', true, false),
            this.prototypes.column('team_name', 't.name', true, false),
            this.prototypes.column('manager_name', 'user_manager.first_name', true, false),
            this.prototypes.column('broker_name', 'user_broker.first_name', true, false),

        ]
    }

    /**
     * Sobreescrita do método básico REST que busca as instâncias de modo
     * a utilizar o novo endpoint com classes service e repository
     *
     * @param {String} url
     * @param {Object} params
     */
    getAll(url, params, config = {}) {
        return this.http.get(
            this.constructor.normalize('availability/units/reserves/new', url),
            {
                params,
                ...config
            }
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    getData(url, params) {
        return this.getAll(url, params)
            .then(response => {
                let data = null
                if (response.data.total) {
                    data = response.data.data.map((item) => {
                        item.id = item.id_reserve
                        delete item.id_reserve

                        return item
                    })

                    response.data.data = data
                } else if (response.data.length) {
                    data = response.data.map((item) => {
                        item.id = item.id_reserve
                        delete item.id_reserve

                        return item
                    })

                    response.data = data
                }

                return response
            })
    }


    getUnitsReservesDeal(deal_id, params) {
        return this.http2.get(`${this.resource}/deal/${deal_id}`, { params })
    }
}